import { CsvMapper } from '@acme/core'
import { useState } from 'react'
import { Funcionario, funcionario as api } from 'service/api'

class FuncionarioMapper extends CsvMapper<Partial<Funcionario>> {}

export function ExportarService() {
    const [isCarregando, setIsCarregando] = useState<boolean>(false)

    async function handleExportarFicha(
        funcionario: Funcionario,
        tipo: 'pdf' | 'csv' | 'xls',
    ) {
        if (!funcionario) return
        setIsCarregando(true)

        if (tipo === 'csv' || tipo === 'xls') {
            new FuncionarioMapper([funcionario]).downloadCsv('ficha-funcionario')
        } else if (tipo === 'pdf') {
            await api.ficha
                .pdf({
                    data: funcionario,
                })
                .finally(() => setIsCarregando(false))
        }
        setIsCarregando(false)
    }

    return {
        handleExportarFicha,
        isCarregando,
    }
}
